(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('ObservationsEdufindmeController', ObservationsEdufindmeController)

    ObservationsEdufindmeController.$inject = [
                '$uibModalInstance',
                'client',
                'type',
                'ObservationsEdufindmeService',
                'toastr',
                '$timeout'
    ];

    function ObservationsEdufindmeController(
            $uibModalInstance,
            client,
            type,
            ObservationsEdufindmeService,
            toastr,
            $timeout) {

        var vm = this;


        vm.errorMessage     = false;
        vm.query            = {};
        vm.user_id          = [];
        vm.message          = '';
        vm.listMessage      = '';
        vm.client           = client;
        vm.type             = type;
        vm.ok               = ok;
        vm.cancel           = cancel;
        vm.save             = save;
        vm.listObservations = listObservations;
        vm.cleanForm        = cleanForm;
        /*PAGINATION*/
        vm.pageChanged      = pageChanged;
        vm.setPage          = setPage;
        vm.to               = [];
        vm.totalItems       = [];
        vm.currentPage      = null;
        vm.itemsPerPage     = [];
        vm.page             = 1;

        activate();

        function activate() {
            vm.listObservations();
        }

        function cleanForm() {
            if (vm.type == 'institutions') {
                vm.adminManageAgent = [];
            }
        }

        function listObservations() {
            if (vm.type == 'agents' || vm.type == 'institutions')
                vm.query['client_id'] = vm.client.user_id;
            else
                vm.query['client_id'] = vm.client.users_id;

            vm.query['type'] = vm.type;

            if(vm.page !== null)
                vm.query['page'] = vm.page;

            ObservationsEdufindmeService.observations(vm.query).then(function (response) {
                vm.listMessages = response.data.data;
                vm.totalItems   = response.data.total;
                vm.to           = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function (err) {

            });
        }

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function save() {
            vm.query;
            vm.query['type']        = vm.type;
            if (vm.type == 'agents' || vm.type == 'institutions')
                vm.query['client_id'] = vm.client.user_id;
            else
                vm.query['client_id'] = vm.client.users_id;

            vm.query['message']     = vm.message;

            ObservationsEdufindmeService.saveObservations(vm.query).then(function (response) {
                toastr.success('Successfully saved!');
                vm.cleanForm();
                vm.listObservations();
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        };

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.listObservations();

        };
    }
})();